var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEticket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.7307692,0 L3.26923077,0 C1.46461538,0 0,1.37454545 0,3.06818182 L0,23.9318182 C0,25.6254545 1.46461538,27 3.26923077,27 L13.7307692,27 C15.5353846,27 17,25.6254545 17,23.9318182 L17,3.06818182 C17,1.37454545 15.5353846,0 13.7307692,0 Z M8.5,25.7727273 C7.82809524,25.7727273 7.28571429,25.2245455 7.28571429,24.5454545 C7.28571429,23.8663636 7.82809524,23.3181818 8.5,23.3181818 C9.17190476,23.3181818 9.71428571,23.8663636 9.71428571,24.5454545 C9.71428571,25.2245455 9.17190476,25.7727273 8.5,25.7727273 Z M13.5714286,22.0909091 L3.42857143,22.0909091 C2.87628668,22.0909091 2.42857143,21.6431938 2.42857143,21.0909091 L2.42857143,3.45454545 C2.42857143,2.9022607 2.87628668,2.45454545 3.42857143,2.45454545 L13.5714286,2.45454545 C14.1237133,2.45454545 14.5714286,2.9022607 14.5714286,3.45454545 L14.5714286,21.0909091 C14.5714286,21.6431938 14.1237133,22.0909091 13.5714286,22.0909091 Z",
    transform: "translate(2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEticket);
export default __webpack_public_path__ + "static/media/eticket.2fb2d93d.svg";
export { ForwardRef as ReactComponent };